import ApplicationSerializer from 'eflex/serializers/application';

export default class WieConfigIconsSerializer extends ApplicationSerializer {
  attrs = {
    fill: {
      embedded: 'always',
    },
  };
}
